import { render, staticRenderFns } from "./NsCarousel.vue?vue&type=template&id=685aef72&scoped=true&"
import script from "./NsCarousel.vue?vue&type=script&lang=js&"
export * from "./NsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsCarousel.vue?vue&type=style&index=0&id=685aef72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685aef72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685aef72')) {
      api.createRecord('685aef72', component.options)
    } else {
      api.reload('685aef72', component.options)
    }
    module.hot.accept("./NsCarousel.vue?vue&type=template&id=685aef72&scoped=true&", function () {
      api.rerender('685aef72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsCarousel.vue"
export default component.exports